<fgb-banner></fgb-banner>

<div class="d-lg-none mobile-member-card">
  <div class="scroll-header-container container bg-primary" [ngClass]="{ 'display-header': showTopMenu }">
    <h4 class="name-title mb-0 text-white text-uppercase font-size-18" *ngIf="memberDetails$ | async as memberDetails">
      {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
    </h4>
    <div class="ms-auto d-flex align-items-center widget-details gap-3">
      <div class="balance-details d-flex bg-glass align-items-center gap-1">
        <span class="icons material-icons font-size-18 text-white" aria-hidden="true">loyalty</span>
        <div class="balance">
          <p class="mb-0 font-size-14 fw-bold text-white">{{ pointsBalance$ | async | number: '1.0-0' : 'en-GB' }}</p>
        </div>
      </div>

      <button class="qrcode-btn text-white bg-glass" (click)="navigateToAccount()">
        <span class="icon material-icons material-mobile-nav text-white">qr_code_2</span>
      </button>
    </div>
  </div>
</div>

<div class="d-lg-none">
  <div class="bg-primary">
    <fgb-mobile-page-header [isHomePage]="true"></fgb-mobile-page-header>
  </div>
</div>

<div class="container animate-in delay-1">
  <div class="pt-3">
    <fgb-vouchers></fgb-vouchers>
  </div>
</div>

<!--Featured challenges (V2)-->
<div class="container mt-4 animate-in delay-2">
  <fgbcl-scorecards-v2-featured></fgbcl-scorecards-v2-featured>
</div>

<div class="container">
  <!-- Featured Rewards -->
  <div class="animate-in delay-3">
    <fgbcl-featured-rewards></fgbcl-featured-rewards>
  </div>

  <!-- Campaign Offers -->
  <div class="animate-in delay-4">
    <fgb-campaigns-v2-offers-list [showAllOffers]="true"></fgb-campaigns-v2-offers-list>
  </div>

  <!-- Announcements -->
  <div class="animate-in delay-5">
    <fgbcl-announcements></fgbcl-announcements>
  </div>
</div>
